import ReactDOM from "react-dom/client";
import "./index.css";

import Auth from "./auth";
import Menu from "./menu";
import LogOut from "./logOut";
import DishRoulette from "./dishRoulette";
import AddRecipe from "./addRecipe";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { StrictMode } from "react";
import MealPlanner from "./mealPlanner";
import RequireAuth from "./requireAuth";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import "./getWeekNumber";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<ThemeProvider theme={theme}>
		<StrictMode>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Auth />} />
					<Route index element={<Auth />} />
					<Route
						path="mealPlanner"
						element={
							<RequireAuth>
								<Menu />
								<LogOut />
								<MealPlanner />
							</RequireAuth>
						}
					/>
					<Route
						path="dishRoulette"
						element={
							<RequireAuth>
								<LogOut />
								<Menu />
								<DishRoulette />
							</RequireAuth>
						}
					/>
					<Route
						path="addRecipe"
						element={
							<RequireAuth>
								<LogOut />
								<Menu />
								<AddRecipe />
							</RequireAuth>
						}
					/>
				</Routes>
			</BrowserRouter>
		</StrictMode>
	</ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
